import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import {ui} from './ui'
import {auth} from './auth'
import {prospect} from './prospect'
import {formulaire} from './formulaire'
import {contact} from './contact'
import {echange} from './echange'
import {proposition} from './proposition'
import {essai} from './essai'
import {alerte} from './alerte'
import {document} from './document'
import {groupe} from './groupe'
import {conseiller} from './conseiller'
import {ref} from './ref'
import {mail} from './mail'
import {sms} from './sms'
import {config} from './config'

Vue.use(Vuex)

const persistOptions = {
  key: 'coprolib-crm',
  paths: ['auth.token', 'auth.me', 'prospect.limitParam']
}

const plugins = [createPersistedState(persistOptions)]

export default new Vuex.Store({
  modules: {
    ui,
    auth,
    prospect,
    formulaire,
    contact,
    echange,
    proposition,
    essai,
    alerte,
    document,
    groupe,
    conseiller,
    ref,
    mail,
    sms,
    config
  },
  plugins
})
